<template>
    <section class="tutorial-card-section">
        <div class="tutorial-card-section__container">
            <CardTitle v-if="!hideTitle" :module="item" />
            <div class="tutorial-card-section__body">
                <component v-for="(section, idx) in sections" :key="String(section.id ?? idx)"
                    :is="resolveComponent(section.displayModeCode)" :item="section" :hideTitle="true" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed, markRaw, type Component } from 'vue'
import type { Module } from '@/api/page_config'
import { CARD_COMPONENT_MAP } from '.'
import CardTitle from './CardTitle.vue'
import TutorialSection from './TutorialSection.vue'

const props = withDefaults(defineProps<{
    item: Module
    hideTitle?: boolean
}>(), { hideTitle: false })

/** 分区数据：优先取 items，其次 fieldData（兼容后端字段差异） */
const sections = computed<Module[]>(() => {
    const items = props.item.items
    if (Array.isArray(items) && items.length > 0) {
        return items
    }
    const fieldData = props.item.fieldData
    if (Array.isArray(fieldData)) {
        return fieldData as unknown as Module[]
    }
    return []
})

/** 解析子分区的 displayModeCode，缺失时回退到 TutorialSection */
function resolveComponent(modeCode: string): Component {
    const comp = CARD_COMPONENT_MAP[modeCode]
    return comp ? markRaw(comp) : markRaw(TutorialSection)
}
</script>

<style scoped lang="scss">
@use '@/assets/styles/variables' as *;

.tutorial-card-section {
    width: 100%;
    background: $color-bg;
}

.tutorial-card-section__container {
    max-width: $container-max-width;
    margin: 0 auto;
    padding: 2rem 1rem;

    @media (min-width: $breakpoint-md) {
        padding: 2.5rem 2rem;
    }

    @media (min-width: $breakpoint-lg) {
        padding: 3rem 2rem;
    }
}

.tutorial-card-section__body {
    display: flex;
    flex-direction: column;
}
</style>
